module.exports = __webpack_public_path__ + "img/public/SiteIcons/locatiionPin.svg?c4a917fc";